import { Moon, Rows, StretchHorizontal, Sun } from 'lucide-react';

import { useDensity } from '../../components/dashboards/lib/useTheme';
import { useTheme } from '../../hooks/useTheme';

import NavMenuItem from './NavMenuItem';

/** Theme + density toggles. Theme is the app-wide preference; density is
 *  the dashboards preference (data-dashboards-density on <html>). */
export default function AppearanceItems() {
  const { theme, toggleTheme } = useTheme();
  const { value: density, set: setDensity } = useDensity();
  return (
    <>
      <NavMenuItem
        icon={theme === 'light' ? Moon : Sun}
        label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
        onClick={() => toggleTheme()}
      />
      <NavMenuItem
        icon={density === 'compact' ? StretchHorizontal : Rows}
        label={density === 'compact' ? 'Comfortable density' : 'Compact density'}
        onClick={() => setDensity(density === 'compact' ? 'comfortable' : 'compact')}
      />
    </>
  );
}
